import React, { useState, useEffect } from 'react'
import volume from './volume.png'

import { Panel} from 'react95';
import { Sounds } from './Sound'
function Clock() {
  const [time, setTime] = useState({ hour: '', min: '', AMPM: '' })
  const [showSoundContainer, setShowSoundContainer] = useState(false)

  const onClick = () => {
    showSoundContainer ? setShowSoundContainer(false) : setShowSoundContainer(true)
  }

  useEffect(() => {
    getTime();
    setInterval(getTime, 30000);
  }, []);

  function getTime() {
    let date = new Date();
    let hour = date.getHours();
    let min = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
    let AMPM = date.getHours() >= 12 ? 'PM' : 'AM';
    setTime({ hour, min, AMPM });
  }

  return (
    <div>
      <div style={showSoundContainer ? null : {position:"absolute",left:"5000px"} }>
      </div>
      <Panel
      variant='well'
      style={{position:"absolute", right:"10px", top:"50%", transform:"translateY(-50%)"}}
    >
      <img src={volume} alt="sound" style={{maxWidth:"25px", paddingRight: " 5px", paddingLeft: " 5px"}} onClick={onClick}/>{`${time.hour}:${time.min} ${time.AMPM}`}
    </Panel>
    </div>
  );
}

export default Clock;